type LabelSortingArgument = {
  label: string;
};

/**
 * Useful for sorting all the arguments that come out of a FetchAutocomplete in alphabetical order.
 */
export function labelSorting(a: LabelSortingArgument, b: LabelSortingArgument) {
  if (a.label < b.label) return -1;
  if (a.label > b.label) return 1;
  return 0;
}
